import React from 'react';
import { faCheck, faClose } from '@fortawesome/free-solid-svg-icons';
import { Card, CardBody, Col, Row } from 'reactstrap';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import AssistantProfileSpeaking from 'components/assistant/AssistantProfileSpeaking';

const ProjectSuggestions = ({setlistView}) => {
  // Mock suggestions data
  const suggestions = [
    { id: 0, title: "Answer and keep Contact with Customers", description: "Drive Customer Satisfaction & Sales" },
    { id: 1, title: "Start a social media campaign", description: "Boost brand awareness" },
    { id: 2, title: "Organize a webinar", description: "Engage with our audience" },
    { id: 3, title: "Launch a customer feedback survey", description: "Gather valuable insights" }
  ];

  /*const suggestions = [
    { id: 1, title: "Organisiere ein Event anlässlich 150 Jahr Feier", description: "Boost brand awareness" },
    { id: 2, title: "E-Mail mit Case Study an alle über 4 Wochen offenen Leads", description: "Re-Engage our audience" },
    { id: 3, title: "Sende Info über Junior BU an neukunden Schwangerschaftsversicherung", description: "Cross-Sell" }
  ];*/

  return (
    <Card className="card-user">
      <CardBody>
        <AssistantProfileSpeaking/>
        <div className="mt-5" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {suggestions.map(suggestion => (
          <div key={suggestion.id} style={{
            background: '#d1e7dd', // A different color to distinguish from memos
            padding: '10px',
            borderRadius: '5px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            fontFamily: 'Arial, sans-serif'
          }}>
            <h3 style={{ marginTop: '0' }}>{suggestion.title}</h3>
            <Row>
                <Col md={9}><p>{suggestion.description}</p></Col>
                <Col md={1}>
                    <IconButtonWithTooltip translationId='go for it' icon={faCheck } onClick={()=> {setlistView(true)}} type="Button"/>
                </Col>
                <Col md={1}>
                    <IconButtonWithTooltip translationId='forget it' icon={faClose } onClick={()=> {}} type="Button"/>
                </Col>
            </Row>
          </div>
        ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default ProjectSuggestions;
